import { createRouter, RouterProvider } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';
import { LoadingOverlay } from '@mantine/core';
import { routeTree } from '@/routeTree.gen';
import { useAppStore } from '@/stores';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    protected?: boolean;
    permissions?: string[];
    icon?: LucideIcon;
    label?: string;
  }
}

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPendingComponent: () => <LoadingOverlay visible />,
  defaultErrorComponent: ({ error, reset }) => {
    return (
      <div>
        <h1>Something went wrong!</h1>
        <p>{error.message}</p>
        <button
          onClick={() => {
            reset();
            window.location.reload();
          }}
        >
          Try Again
        </button>
      </div>
    );
  }, // Global error handler
});

router.subscribe('onBeforeLoad', ({ pathChanged }) => {
  if (pathChanged) {
    useAppStore.getState().pageLoadingToggle(true);
  }
});

router.subscribe('onLoad', () => {
  useAppStore.getState().pageLoadingToggle(false);
});

const RouteProvider = () => {
  return <RouterProvider router={router} />;
};

export default RouteProvider;
